<template>
    <div>
        <v-data-table :headers="header"
                      :items="data"
                      :loading="loading2"
                      :search="search"
                      class="elevation-1"
                      mobile-breakpoint="0">
            
        </v-data-table>
    </div>
</template>

<script>
import ProductMixin from "@/mixins/Product";

export default {
    data: () => ({
        loading2: true,
        search: "",
        header: [
            { text: "Keyword", value: "keyword", class: 'primary white--text' },
            { text: "Count", value: "count", class: 'primary white--text' }
        ],
        data: [],
    }),
    mixins: [ProductMixin],
    created() {
        this.fetchKeywords();
    },
    methods: {
        async fetchKeywords() {
            this.data = await this.action("google");
            this.loading2 = false;
        }
    }
}
</script>